module.exports = function(options)
{
    var selectBoxSelector = 'select[id$="-key"]';
    var minFieldSelector = 'input[id$="-min"]';
    var maxFieldSelector = 'input[id$="-max"]';

    var helper = InlineFormHelper(options);
    var lockTypesCheckbox = helper.formElement.querySelector('#lock-analysis-types');

    function getAllSelectBoxes()
    {
        return  helper.formElement.querySelectorAll(selectBoxSelector);
    }

    lockTypesCheckbox.addEventListener('change', function(e)
    {
        var allSelectBoxes = getAllSelectBoxes();

        for(var i = 0; i < allSelectBoxes.length; i++)
        {
            updateSelectLock(allSelectBoxes[i]);
        }
    });

    function updateSelectLock(select)
    {
        if (lockTypesCheckbox.checked)
        {
            select.setAttribute('readonly', true);
            select.setAttribute('tabindex', -1);
        }
        else
        {
            select.removeAttribute('tabindex');
            select.removeAttribute('readonly');
        }
    }

    helper.afterAdd = function(addedForm, previous)
    {
        try
        {
            addedForm.classList.remove('row');
            addedForm.classList.add('material-required-analysis');

            var allSelectBoxes = getAllSelectBoxes();
            var currentSelectBox = addedForm.querySelector(selectBoxSelector);

            updateSelectLock(currentSelectBox);

            selectNextAvailable(currentSelectBox, allSelectBoxes, [0]);
        
        }
        catch (err)
        {
            console.error(err)
        }
    };
    function setAllValuesto(fields, value)
    {
        for(var i = 0; i < fields.length; i++)
        {
            fields[i].value = value;
        }
    }

    window.setAllRequiredAnalysisMinValuesTo = function(value)
    {
        setAllValuesto(helper.formElement.querySelectorAll(minFieldSelector), value)
    }    
    
    window.setAllRequiredAnalysisMaxValuesTo = function(value)
    {
        setAllValuesto(helper.formElement.querySelectorAll(maxFieldSelector), value)
    }
}